import type { PrescriptionT } from '@lotushealth/lotushealth_js_sdk/schemas';

import { toTableCellText } from '@/shared/lib/table';

/**
 * ``fallback`` is used when the primary prescription has no ``DisplayName``
 * — common on refills where ``RequestedPrescription`` is a stub but
 * ``OriginalPrescription`` carries the friendly name.
 */
export function buildMedicationLabel(
  prescription: PrescriptionT | null | undefined,
  fallback: PrescriptionT | null | undefined = null
): string {
  return toTableCellText(prescription?.DisplayName ?? fallback?.DisplayName);
}

/** ``"<type> · <subType>"`` when subType present, else ``"<type>"``. */
export function buildRxChangeTypeLabel(
  type: string | null | undefined,
  subType: string | null | undefined
): string {
  const typeLabel = toTableCellText(type);
  const trimmedSubType = subType?.trim();
  return trimmedSubType ? `${typeLabel} · ${trimmedSubType}` : typeLabel;
}
